export default __webpack_public_path__ + "static/media/branding-black-webfont.6c839ac5.woff";